import { render, staticRenderFns } from "./moreHTFT.vue?vue&type=template&id=06f92b8b&lang=pug&"
import script from "./moreHTFT.vue?vue&type=script&lang=js&"
export * from "./moreHTFT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports